import * as betgalaxy from './MarketLayout.styles.betgalaxy';
import * as betprofessor from './MarketLayout.styles.betprofessor';
import * as betroyale from './MarketLayout.styles.betroyale';
import * as fiestabet from './MarketLayout.styles.fiestabet';
import * as goldenrush from './MarketLayout.styles.goldenrush';
import * as juicybet from './MarketLayout.styles.juicybet';
import * as puntcity from './MarketLayout.styles.puntcity';
import * as puntgenie from './MarketLayout.styles.puntgenie';
import * as questbet from './MarketLayout.styles.questbet';
import * as sterlingparker from './MarketLayout.styles.sterlingparker';
import * as vikingbet from './MarketLayout.styles.vikingbet';
import * as volcanobet from './MarketLayout.styles.volcanobet';
import * as wellbet from './MarketLayout.styles.wellbet';
import * as forsport from './MarketLayout.styles.forsport';
import * as junglebet from './MarketLayout.styles.junglebet';
import * as sugarcastle from './MarketLayout.styles.sugarcastle';
import * as oldgill from './MarketLayout.styles.oldgill';
import * as buffalobet from './MarketLayout.styles.buffalobet';
import * as titanbet from './MarketLayout.styles.titanbet';
import * as gigabet from './MarketLayout.styles.gigabet';
import * as slambet from './MarketLayout.styles.slambet';
import * as betstride from './MarketLayout.styles.betstride';
import * as templebet from './MarketLayout.styles.templebet';
import * as goldenbet888 from './MarketLayout.styles.goldenbet888';
import * as hyperbet from './MarketLayout.styles.hyperbet';
import * as bet777 from './MarketLayout.styles.bet777';
import * as chromabet from './MarketLayout.styles.chromabet';
import * as bet575 from './MarketLayout.styles.bet575';
import * as epicodds from './MarketLayout.styles.epicodds';
import * as pyramidbet from './MarketLayout.styles.pyramidbet';
import * as magnumbet from './MarketLayout.styles.magnumbet';
import { EThemesOG } from '@/constants/themeConfig';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  betgalaxy,
  betprofessor,
  betroyale,
  fiestabet,
  goldenrush,
  juicybet,
  puntcity,
  puntgenie,
  questbet,
  sterlingparker,
  vikingbet,
  volcanobet,
  wellbet,
  forsport,
  junglebet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  gigabet,
  slambet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  pyramidbet,
  magnumbet,
};
